module.exports = __webpack_public_path__ + "static/media/Kratom.5d00f0a2.jpg";